export const rotationHandler = {
    register: () => {},
};
